<template>
  <div class="animated fadeIn presupuestos-internos presupuestos-internos-produccion">
    <b-row>
      <b-col xl="12">
        <b-form>
          <app-presupuesto-interno
            :presupuestoNumero="presupuestoNumero"
            :cliente="cliente"
            :accion="accion"
            :prioridad="prioridad"
            :fechaRegistro="fechaRegistro"
            :fechaEntrega="fechaEntrega"
            :usuarios="usuarios"
            :showMoneda="true"
            :moneda="moneda"
            :monedaCotizacion="monedaCotizacion"
            :labelCols="2">
          </app-presupuesto-interno>

          <b-card header="Ordenes de Trabajo">
            <b-table 
                small 
                responsive="sm"
                class="registro-ordenes" 
                :items="ordenesTrabajoDatos" 
                :fields="ordenesTrabajoFields">
              <template v-slot:cell(rubroTrabajo)="data">
                {{ data.item.rubroTrabajo }}
              </template>
              <template v-slot:cell(costoEstimadoTotal)="data">
                <template v-if="data.item.readOnly">
                  {{ data.item.costoEstimadoTotal | moneda(data.item.moneda) }}
                </template>
                <template v-if="!data.item.readOnly">
                  {{ data.item.moneda }}
                  <input type="number" step="0.01"
                      v-model="data.item.costoEstimadoTotal"
                      @input="updateCostoOrden(data.item)"/>
                </template>
              </template>
              <template v-slot:cell(costoSubtrabajos)="data">
                {{ data.item.costoSubtrabajos | moneda }}
              </template>
              <template v-slot:cell(costoReal)="data">
                {{ data.item.costoReal | moneda }}
              </template>
              <template v-slot:cell(tieneImagenes)="data">
                <template v-if="data.item.tieneImagenes">
                  <i class="fa fa-image"></i>
                </template>  
              </template>
              <template v-slot:cell(opciones)="data">
                <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                  <template slot="button-content">
                    <i class="fa fa-ellipsis-v"></i>
                  </template>
                  <b-dropdown-item 
                      v-if="!data.item.readOnly"
                      @click.stop="editarOrden(data.item)">
                    <i class="fa fa-edit"></i>Editar Datos de la Orden</b-dropdown-item>
                  <b-dropdown-item 
                      v-if="data.item.readOnly"
                      @click.stop="consultarOrden(data.item)">
                    <i class="fa fa-info"></i>Consultar Datos de la Orden</b-dropdown-item>
                  <b-dropdown-item
                      @click.stop="consultarImagenes(data.item)">
                    <i class="fa fa-image"></i>Consultar Imágenes de la Orden</b-dropdown-item>
                  <b-dropdown-item 
                      @click.stop="asignarUsuarioOrden(data.item)">
                    <i class="fa fa-user"></i>Asignar Usuarios</b-dropdown-item>
                </b-dropdown>
              </template>

              <template v-slot:cell(detailShowing)="row">
                <b-btn class="detailShowing" 
                    size="sm" 
                    v-if="row.item.descripcion != '' || row.item.subtrabajos" 
                    @click.stop="row.toggleDetails">
                  {{ ( row.detailsShowing) ? '-' : '+' }}
                </b-btn>            
              </template>

              <template v-slot:row-details="row">
                <b-row>
                  <b-col cols="12">
                    <p class="descripcion">{{ row.item.descripcion }}</p>
                  </b-col>
                </b-row>
                <!-- Subtrabajos de la orden -->
                <b-row v-if="row.item.subtrabajos.length != 0">
                  <b-col cols="12">
                    <b-table 
                        small 
                        responsive="sm"
                        class="registro-ordenes subtrabajos" 
                        :items="row.item.subtrabajos" 
                        :fields="subtrabajosFields">

                    <template v-slot:cell(costo)="data">
                      {{  ( data.item.costoUnitario ? data.item.cantidad * data.item.costo : data.item.costoTotal) | moneda }}
                    </template>

                    </b-table>        
                  </b-col>
                </b-row>
              </template>
            </b-table>

            <b-table 
                small 
                responsive="sm"
                class="registro-ordenes totales" 
                :items="ordenesTrabajoDatosTotales" 
                :fields="ordenesTrabajoDatosTotalesFields">
              <template v-slot:cell(costoEstimadoTotal)="data">
                {{ data.item.costoEstimadoTotal | moneda }}
              </template>
              <template v-slot:cell(costoSubtrabajos)="data">
                {{ data.item.costoSubtrabajos | moneda }}
              </template>
              <template v-slot:cell(costoReal)="data">
                {{ data.item.costoReal | moneda }}
              </template>
            </b-table>
          </b-card>
        </b-form>
      </b-col>
    </b-row>
    
    <b-modal ref="ordenTrabajoUsuariosModal"
        title="Asignación de Usuarios"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-orden-trabajo-usuarios
        :ordenTrabajoId="ordenTrabajoId"
        @close="closeAsignacionUsuariosOrden">
      </app-orden-trabajo-usuarios>  
    </b-modal>

    <b-modal ref="ordenTrabajoImagenesModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalOrdenTrabajo">
      <app-orden-trabajo-imagenes
        :ordenTrabajoId="ordenTrabajoId"
        :readonly="Boolean(true)"
        @close="closeImagenes">
      </app-orden-trabajo-imagenes>  
    </b-modal>

    <app-a-b-m-button
      v-if="!cerrado"
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <div class="fixed-btn" v-if="cerrado">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import PresupuestoInternoDatos from '../shared/presupuestoInterno';
import OrdenTrabajoUsuarios from '../ordenestrabajos/UsuariosSeleccion';
import OrdenTrabajoImagenes from '../ordenestrabajos/Imagenes';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestointernoproduccion/getField',
  mutationType: 'presupuestointernoproduccion/updateField',
});

export default {
  name: 'ABM',
  components: {
    appPresupuestoInterno: PresupuestoInternoDatos,
    appOrdenTrabajoUsuarios: OrdenTrabajoUsuarios,
    appOrdenTrabajoImagenes: OrdenTrabajoImagenes,
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    msjModal, 
    confirmModal, 
  ],
  props: {
    inicializar:  {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      ordenSeleccionada: null,

      ordenesTrabajoFields: [
        { 
            key: 'tieneImagenes',
            label: '',
            class: 'text-center'
        },
        {
          key: 'detailShowing',
          label: '',
          class: 'text-center'
        },
        {
          key: 'id',
          label: 'Nro.Orden',
          class: "text-right"
        },
        {
          key: 'rubroTrabajo',
          label: 'Rubro',
          sortable: true
        },
        {
          key: 'titulo',
          sortable: true
        },
        { 
          key: 'cantidad', 
          class: "text-right"
        },
        // {
        //   key: 'moneda',
        // },
        { 
            key: 'costoEstimadoTotal', 
            label: 'Costo Estimado',
            class: "text-right" 
        },
        { 
            key: 'costoSubtrabajos', 
            label: 'Total Subtrabajos',
            class: "text-right" 
        },
        { 
            key: 'costoReal', 
            class: "text-right" 
        },
        { 
            key: 'opciones',
            label: '',
            class: 'text-center'
        },
      ],

      ordenesTrabajoDatosTotalesFields: [
        { key: 'col1' },
        { key: 'col2' },
        { key: 'col3' },
        { key: 'col4' },
        { 
          key: 'totales',
          class: "text-right" 
        },
        { key: 'col5' },
        { 
            key: 'costoEstimadoTotal', 
            class: "text-right" 
        },
        { 
            key: 'costoSubtrabajos', 
            class: "text-right" 
        },
        { 
            key: 'costoReal', 
            class: "text-right" 
        },
        { key: 'col9' },
      ],

      subtrabajosFields: [
        {
            key: 'articuloTipo',
            label: 'Tipo de Articulo',
        },
        {
            key: 'cantidad',
            class: "text-right" 
        },
        {
            key: 'col3',
            label: ''
        },
        {
            key: 'costo',
            class: "text-right" 
        },
        {
            key: 'col6',
            label: ''
        },
      ],

      saved: false,
      cancelled: false,
      // accesoAbrirOrden: false,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'fechaRegistro',
      'fechaEntrega',
      'presupuestoNumero',
      'cliente',
      'accion',
      'prioridad',
      'moneda',
      'monedaCotizacion',
      'usuarios',
      'ordenesTrabajos',
      'dirty',

      'cerrado',

      'ordenesTrabajoDatos',  
      'ordenesTrabajoDatosTotales',
      'vistaOrdenes',
    ]),

    ordenTrabajoId() {
      return this.ordenSeleccionada? this.ordenSeleccionada.id : 0;
    }
  },  
  created() {
    let presupuestoId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        presupuestoId = this.$route.params.id;
      }
    }

    if (this.inicializar || this.id == 0) {
      this.$store.dispatch('presupuestointernoproduccion/inicializar', presupuestoId);
    }
  },
  methods: {
    saveContinue() {
      this.save(true);
    },
    save(saveContinue) {
      this.showSpinner();
      this.$store.dispatch('presupuestointernoproduccion/save')
        .then(() => {
          if (saveContinue) {
            this.showModalMsj('Los cambios se registraron con éxito', null, null, 'light');
          } else {
            this.showModalMsj('Los cambios se registraron con éxito', this.goBack, this.goBack, 'light');
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    goBack() {
      this.$router.push({ name: "PresupuestosInternos" });
    },
    editarOrden(item) {
      if (this.dirty) {
        this.showModalConfirm('Una o más de las ordenes han sido modificadas, deberá guardar los cambios antes de seguir.\nDesea guardar la información en este momento?', 
          this.borrar.saveContinue, 'Si', null, 'No')
      } else {
        this.$store.dispatch('presupuestointernoproduccion/selectOrden', item.ordenTrabajo)
          .then (() => this.$router.push({ name: 'OrdenTrabajoProduccion', params: { id: item.id } }))
          .catch(error => this.showErrorMsj(error))
      }
    },
    updateCostoOrden(item) {
      let params = {
          ordenTrabajo: item.id,
          costoEstimadoTotal: item.costoEstimadoTotal,
      }
      this.$store.dispatch('presupuestointernoproduccion/updateCostoOrden', params);
    },
    asignarUsuarioOrden(item) {
      this.ordenSeleccionada = item;
      this.$refs.ordenTrabajoUsuariosModal.show();
    },
    closeAsignacionUsuariosOrden() {
      this.$refs.ordenTrabajoUsuariosModal.hide();
    },
    consultarOrden(item) {
      this.$router.push({ name: 'OrdenTrabajoProduccion',
          params: { id: item.id } });
    },
    consultarImagenes(item) {
      this.ordenSeleccionada = item;
      this.$refs.ordenTrabajoImagenesModal.show()
    },
    closeImagenes() {
      this.$refs.ordenTrabajoImagenesModal.hide()
    },
    resetDirty() {
      this.$store.dispatch('presupuestointernoproduccion/resetDirty');
    },
    cancelarBeforeLeave(to) {
      /* Guardamos el parametro */
      this.routeNext = to;

      this.showModalConfirm('¿Desea salir sin registrar los cambios en la orden?', 
        this.borrar.leave, 'Si', null, 'No')
    },
    leave() {
      // this.$v.$reset();
      this.$store.dispatch('presupuestointernoproduccion/resetDirty');

      this.$router.push({ name: this.routeNext.name, 
                          params: this.routeNext.params});
    },    
  },
  beforeRouteLeave (to, from, next) {
    if (to.name.trim().toLowerCase() == 'login') {
      next();
    } else {
      if (this.dirty) {
        this.cancelarBeforeLeave(to);
        /* Cancelamos hasta que confirme el usuario */
        next(false);
      } else {
        next();
      }
    }
  },  
}
</script>

<style>
  .presupuestos-internos-produccion .registro-ordenes table td {
    vertical-align: middle;
    border-top: 1px solid #c8ced3 !important;
  }
  .presupuestos-internos-produccion .registro-ordenes table td[aria-colindex="1"] {
    width: 20px;
  }
  .presupuestos-internos-produccion .registro-ordenes table td[aria-colindex="2"] {
    width: 20px;
  }
  .presupuestos-internos-produccion .registro-ordenes table td[aria-colindex="3"] {
    width: 5%;
  }
  .presupuestos-internos-produccion .registro-ordenes table td[aria-colindex="4"] {
    width: calc(24% - 40px);
  }
  .presupuestos-internos-produccion .registro-ordenes table td[aria-colindex="5"] {
    width: calc(23% - 35px);
  }
  .presupuestos-internos-produccion .registro-ordenes table td[aria-colindex="6"],
  .presupuestos-internos-produccion .registro-ordenes table td[aria-colindex="7"],
  .presupuestos-internos-produccion .registro-ordenes table td[aria-colindex="8"],
  .presupuestos-internos-produccion .registro-ordenes table td[aria-colindex="9"] {
    width: 12%;
  }
  .presupuestos-internos-produccion .registro-ordenes table td[aria-colindex="10"] {
    width: 30px;
  }

  .presupuestos-internos-produccion .registro-ordenes table td input {
    position: relative;
    width: 70% !important;
    left: 5% !important;
  }

  .presupuestos-internos-produccion .registro-ordenes table td > i.fa-image {
    color: gray;
  }

  /* Formato heredado */
  .presupuestos-internos-produccion .registro-ordenes table td[aria-colindex="8"] {
    color: #23282c !important;
  }

  /* Subtrabajos asociados */
  .presupuestos-internos-produccion .registro-ordenes table p.descripcion {
    margin-bottom: 5px;
    padding-left: 9%;
    width: 40%;
    white-space: pre-wrap;
  }
  .presupuestos-internos-produccion .registro-ordenes .subtrabajos {
    padding-left: 9%;
  }
  .presupuestos-internos-produccion .registro-ordenes .subtrabajos table th {
    border-top: none;
  }
  .presupuestos-internos-produccion .registro-ordenes .subtrabajos table td[aria-colindex="1"] {
    width: 54%;
  }
  .presupuestos-internos-produccion .registro-ordenes .subtrabajos table td[aria-colindex="2"],
  .presupuestos-internos-produccion .registro-ordenes .subtrabajos table td[aria-colindex="3"], 
  .presupuestos-internos-produccion .registro-ordenes .subtrabajos table td[aria-colindex="4"] {
    width: 12%;
  }
  .presupuestos-internos-produccion .registro-ordenes .subtrabajos table td[aria-colindex="5"] {
    width: 5%;
  }

  .presupuestos-internos-produccion .registro-ordenes.totales table {
    margin-bottom: 0;
  }
  .presupuestos-internos-produccion .registro-ordenes.totales table th {
    display: none;
  }
  .presupuestos-internos-produccion .registro-ordenes.totales table td {
    border: none;
  }
  .presupuestos-internos-produccion .registro-ordenes.totales table tr {
    font-size: 1.2em;
  }
</style>
